/**
 * `viewing_rooms` — salles privées pour un collectionneur (base galerie, 4.1).
 * Seul anglicisme conservé du métier (2.2). Le jeton n'existe en base que
 * haché (`jetonHash`) ; `null` tant qu'aucun lien n'a été tiré.
 */
import { z } from 'zod';
import { bilingueSchema, CHAMPS_DOCUMENT, idSchema, withAudit } from './commun.js';
export const ETATS_SALLE = ['sans_lien', 'active', 'expiree', 'revoquee'];
export const DUREE_SALLE_DEFAUT_JOURS = 14;
export const DUREE_SALLE_MAX_JOURS = 90;
export const OEUVRES_PAR_SALLE_MAX = 40;
export const MOT_DE_PASSE_SALLE_MIN = 8;
/** Une ouverture : la date, et l'empreinte du visiteur (jamais son adresse). */
export const ouvertureSchema = z.object({ date: z.date(), adresseHachee: z.string() });
export const viewingRoomSchema = withAudit(z.object({
    _id: idSchema,
    titre: bilingueSchema,
    texte: bilingueSchema.optional(),
    oeuvres: z.array(idSchema).min(1).max(OEUVRES_PAR_SALLE_MAX),
    contactId: idSchema.nullable(),
    jetonHash: z.string().nullable(),
    hoteLien: z.string().nullable(),
    lienEmisLe: z.date().nullable(),
    expireLe: z.date(),
    prixVisibles: z.boolean().default(false),
    motDePasseHash: z.string().nullable(),
    revoqueeLe: z.date().nullable(),
    ouvertures: z.array(ouvertureSchema).default([]),
    nombreOuvertures: z.int().min(0).default(0),
    premiereOuvertureLe: z.date().optional(),
    derniereOuvertureLe: z.date().optional(),
}));
export const viewingRoomCreationSchema = viewingRoomSchema
    .omit({
    ...CHAMPS_DOCUMENT,
    jetonHash: true,
    hoteLien: true,
    lienEmisLe: true,
    motDePasseHash: true,
    revoqueeLe: true,
    ouvertures: true,
    nombreOuvertures: true,
    premiereOuvertureLe: true,
    derniereOuvertureLe: true,
})
    .extend({
    contactId: idSchema.nullish(),
    motDePasse: z.string().min(MOT_DE_PASSE_SALLE_MIN).optional(),
});
export const viewingRoomMiseAJourSchema = viewingRoomCreationSchema.partial();
/** L'état d'une salle, à un instant : la révocation d'abord, puis le terme, puis le lien. */
export function etatDeLaSalle(salle, maintenant) {
    if (salle.revoqueeLe !== null)
        return 'revoquee';
    if (salle.expireLe.getTime() <= maintenant.getTime())
        return 'expiree';
    return salle.jetonHash === null ? 'sans_lien' : 'active';
}
//# sourceMappingURL=viewing-rooms.js.map